import React, { useMemo } from 'react';
import { useLocalizedStrings } from 'app/localization/Context';
import { doesAnyBindHaveError } from 'app/model/BindData';

import { ReactComponent as IconDevices } from 'images/homeTab/devices.svg';
import { ReactComponent as IconScenes } from 'images/homeTab/scenarios.svg';
import { ReactComponent as IconAutomations } from 'images/homeTab/binds.svg';
import { ReactComponent as IconPieChart } from 'images/homeTab/pie-chart.svg';
import { ReactComponent as IconReports } from 'images/homeTab/reports.svg';
import { ReactComponent as IconSettings } from 'images/homeTab/settings.svg';

import "./HomeTab.scss"

function HomeTabBar({ gateway, page, setPage }) {
    const gwUpdateInfo = gateway.gwUpdateInfo;
    const needToShowVersionAlert = (
        gwUpdateInfo.isUpdateNotificationSupported === false ||
        gwUpdateInfo.isNewerVersionAvailable
    );
    const devices = gateway.devices;
    const showMultiOTAAlert = useMemo(() => devices.filter(d => d.ota_exists === true).length > 0, [devices]) && (gateway.negotiatedProtocol.canOTADeviceFromClient);
    const showSettingsRedDot = needToShowVersionAlert || (gateway.allUsers.pendingUsers.length > 0) || showMultiOTAAlert;

    const showBindsRedDot = useMemo(() => {
        return doesAnyBindHaveError(gateway.binds);
    }, [gateway.binds]);

    return (
        <div className="home-tab-bar">
            <HomeTab pageName='devices' activeTab={page} setActiveTab={setPage} negotiatedProtocol={gateway.negotiatedProtocol} />
            <HomeTab pageName='scenarios' activeTab={page} setActiveTab={setPage} negotiatedProtocol={gateway.negotiatedProtocol} />
            <HomeTab pageName='binds' activeTab={page} setActiveTab={setPage} negotiatedProtocol={gateway.negotiatedProtocol} showRedDot={showBindsRedDot} />
            <HomeTab pageName='reports' activeTab={page} setActiveTab={setPage} negotiatedProtocol={gateway.negotiatedProtocol} />
            <HomeTab pageName='settings' activeTab={page} setActiveTab={setPage} negotiatedProtocol={gateway.negotiatedProtocol} showRedDot={showSettingsRedDot} />
        </div>
    );
}

function HomeTab({ pageName, activeTab, setActiveTab, showRedDot, negotiatedProtocol }) {
    const s = useLocalizedStrings();

    const active = activeTab === pageName;
    const label = {
        'devices': s.home,
        'scenarios': s.scenarios,
        'binds': s.binds,
        'reports': s.logs,
        'settings': s.settings,
    }[pageName]
    const pageIcon = {
        'devices': IconDevices,
        'scenarios': IconScenes,
        'binds': IconAutomations,
        'reports': negotiatedProtocol.supportInsightsAndCharts? IconPieChart : IconReports,
        'settings': IconSettings,
    }[pageName]

    return (
        <div className="home-tab-element">
            {React.createElement(pageIcon, {
                className: (active ? "home-tab-image active" : "home-tab-image")
            })}
            <div className={active ? "home-tab-name active" : "home-tab-name"} >{label}</div>
            <div className="home-tab-on-click-overlay" onClick={
                () => {
                    if (!active) {
                        setActiveTab(pageName);
                    }
                }} />

            {showRedDot ?
                <div className="red-dot" /> : null}
        </div >
    );
}

export default HomeTabBar;